exports.baseURL = 'https://admin.almasachatapp.chat/';
exports.key = 'bdgr1SU67uBN8W160OCHybxwGMa24h1oXXOV3qjP';
exports.projectName = 'AlmasaChat';
